// Pure TypeScript interfaces for better IDE support and performance
export interface RemovePictureResponse {
  status: string;
} 